import { createContext, useContext } from 'react';
export const AssociatedObjectsCardContext = /*#__PURE__*/createContext(undefined);

// TODO: Remove this (https://git.hubteam.com/HubSpot/customer-data-sidebar/issues/3930)

export const AssociatedObjectsCardPartialContext = /*#__PURE__*/createContext(undefined);
export const useAssociatedObjectsCardContext = () => {
  const context = useContext(AssociatedObjectsCardContext);
  const partialContext = useContext(AssociatedObjectsCardPartialContext);
  if (context) return context;
  if (partialContext) return partialContext;
  throw new Error('AssociatedObjectsCardContext is empty or not found');
};
export const AssociatedObjectsCardContentPartialContext = /*#__PURE__*/createContext(undefined);
export const useAssociatedObjectsCardContentContext = () => {
  const context = useContext(AssociatedObjectsCardContext);
  const partialContext = useContext(AssociatedObjectsCardContentPartialContext);
  if (context) return context;
  if (partialContext) return partialContext;
  throw new Error('AssociatedObjectsCardContext or AssociatedObjectsCardContentPartialContext is empty or not found');
};